import Component from '@glimmer/component';

import ReportsViewerImageCtComponent from 'webapp/components/reports/viewer/image-ct';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

export interface Args {
	model: ReportSlideFragment;
}

export default class ReportsViewerFragmentImageComponent<T extends Args> extends Component<T> {
	<template>
		<div class="fragment fragment--image">
			<ReportsViewerImageCtComponent @model={{@model}} />
		</div>
	</template>
}
